import React from "react";

const Safeguarding = () => {
  // Make sure this path matches your public folder structure
  const pdfUrl = "/Bantu_Notts_Safeguarding_Policy.pdf";

  const items = [
    {
      title: "Procedures",
      text:
        "Clear steps for disclosures, reporting, and managing allegations, aligned with local authority guidance.",
      icon: (
        <svg viewBox="0 0 24 24" className="h-6 w-6" aria-hidden>
          <path
            d="M12 2l7 4v5c0 5-3.5 9-7 11-3.5-2-7-6-7-11V6l7-4z"
            fill="currentColor"
          />
        </svg>
      ),
    },
    {
      title: "Safer Recruitment & Conduct",
      text:
        "DBS checks, references, code of conduct, and whistleblowing routes to maintain a safe culture.",
      icon: (
        <svg viewBox="0 0 24 24" className="h-6 w-6" aria-hidden>
          <path
            d="M12 12a5 5 0 100-10 5 5 0 000 10zm-9 9a9 9 0 1118 0v1H3v-1z"
            fill="currentColor"
          />
        </svg>
      ),
    },
    {
      title: "Training & Review",
      text:
        "Induction and refresher training with annual policy review (or sooner if required).",
      icon: (
        <svg viewBox="0 0 24 24" className="h-6 w-6" aria-hidden>
          <path
            d="M4 5h16v2H4V5zm0 4h10v2H4V9zm0 4h16v2H4v-2zm0 4h10v2H4v-2z"
            fill="currentColor"
          />
        </svg>
      ),
    },
  ];

  return (
    <section
      id="safeguarding"
      className="relative overflow-hidden bg-[#FFE8BA] py-12 md:py-16"
    >
      {/* Warm vignette to match the rest of the site */}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(60%_60%_at_100%_0%,rgba(245,158,11,0.12),transparent_60%),radial-gradient(60%_60%_at_0%_100%,rgba(234,88,12,0.12),transparent_65%)]" />

      <div className="relative mx-auto max-w-7xl px-6 md:px-10 lg:px-12">
        {/* Header pill */}
        <h2 className="text-center text-neutral-900 text-[28px] md:text-[36px] font-extrabold tracking-tight bg-white/70 backdrop-blur ring-1 ring-amber-200 shadow-sm rounded-2xl px-5 py-3">
          Safeguarding at Bantu Notts CIC
        </h2>

        {/* Cards */}
        <div className="mt-8 md:mt-10 grid gap-6 md:grid-cols-3">
          {items.map((it, i) => (
            <article
              key={i}
              className="rounded-3xl bg-white/85 backdrop-blur-sm ring-1 ring-amber-200 shadow-md p-6 md:p-7"
            >
              <div className="mb-4 inline-flex items-center justify-center h-11 w-11 rounded-xl text-amber-900 ring-1 ring-amber-200 bg-amber-50">
                {it.icon}
              </div>
              <h3 className="font-bold text-neutral-900 text-lg md:text-xl">
                {it.title}
              </h3>
              <p className="mt-2 text-sm md:text-base leading-relaxed text-neutral-700">
                {it.text}
              </p>
            </article>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
          <a
            href={pdfUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center rounded-full bg-gradient-to-r from-amber-500 via-orange-500 to-amber-600 px-6 py-3 text-sm md:text-base font-semibold text-white shadow-md hover:opacity-90 transition focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400/60"
          >
            View Full Safeguarding Policy (PDF)
          </a>
          <a
            href={pdfUrl}
            download
            className="inline-flex items-center justify-center rounded-full px-6 py-3 text-sm md:text-base font-medium text-amber-900 ring-1 ring-amber-300 bg-amber-50 hover:bg-amber-100 transition"
          >
            Download PDF
          </a>
        </div>
      </div>
    </section>
  );
};

export default Safeguarding;
